import { OrderPaymentCardCreation } from './order-payment-card';

export class LaminatedCardPaymentCreation extends OrderPaymentCardCreation {}
